const moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_ucl_fpds_button_js-node_modules_ucl_fpds_card_js-node_modules_ucl_fpds_c-c7ab17"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("src_modules_App_tsx-webpack_sharing_consume_default_react-dom_react-dom")]).then(() => (() => ((__webpack_require__(/*! ./src/modules/App */ "./src/modules/App.tsx")))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});